// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".3.0.1." + __webpack_require__.h() + ".min.js";
};